import { Typography, Button} from "@mui/material";

const Success = ({ close }) => {

  return (
    <div
      style={{
        height: "100vh",
        padding: 20,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Typography variant="h5" align="center">
            You Are Registered!
          </Typography>
          <Typography>
            What next? Close this dialog and click on your Event Profiles. You
            should now see a Skill Swap profile. Click on that and fill out the
            profile (should only take a few minutes). Then keep a look out for
            upcoming match emails. Be sure to check your spam folder as well. We
            will send the matches once a day around 5PM.
          </Typography>
          <Typography></Typography>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          gap: 10,
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
      
        <Button variant="outlined" onClick={close}>
          Close
        </Button>
      </div>
    </div>
  );
};

export default Success;
